<template>
  <div class="home-container">
    <div class="home-content">
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="上下架"
                prop="status"
                label-width="100px"
                style="width: 80%"
              >
                <el-select v-model="searchForm.status" placeholder="请选择">
                  <el-option label="上架" :value="1"></el-option>
                  <el-option label="下架" :value="-1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="sort" label="排序" align="center" width="200px">
          <template slot-scope="scope">
            <el-input-number style="width: 170px" v-model="scope.row.sort" :precision="0" :min="0" :max="99999999" placeholder="请输入排序" @change="updataSort(scope.row)"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="主题类型名称" align="center">
        </el-table-column>
        <el-table-column prop="remark" label="描述" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="status" label="上下架" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >编辑</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small" style="color: #f53f3f;"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%" @close="close" :close-on-click-modal="false">
        <el-form
          ref="form"
          :model="addData"
          label-width="150px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="排序：" prop="sort">
                <el-input-number style="width: 250px" v-model="addData.sort" :precision="0" :min="0" :max="99999999" placeholder="请输入排序"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="主题类型名称：" prop="title">
                <el-input
                  placeholder="请输入主题类型名称"
                  v-model="addData.title"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="描述：" prop="remark">
                <el-input
                  placeholder="请输入描述"
                  v-model="addData.remark"
                  type="textarea"
                  show-word-limit
                  rows="5"
                  maxlength="250"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="颜色：" prop="color">
                <el-color-picker v-model="addData.color"></el-color-picker>
                <!-- <el-radio-group v-model="addData.color">
                  <el-radio :label="1">
                    <div class="c1 color"></div>
                  </el-radio>
                  <el-radio :label="2">
                    <div class="c2 color"></div>
                  </el-radio>
                  <el-radio :label="3">
                    <div class="c3 color"></div>
                  </el-radio>
                  <el-radio :label="4">
                    <div class="c4 color"></div>
                  </el-radio>
                  <el-radio :label="5">
                    <div class="c5 color"></div>
                  </el-radio>
                </el-radio-group> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="上传图片：" prop="img">
                <upload
                  :url.sync="addData.img"
                  :src="addData.img"
                  type="img"
                  :width="670"
                  :height="323"
                ></upload>
                <div style="color: red">*(建议尺寸670px * 323px)）</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
export default {
  components: {
    upload,
  },
  data() {
    return {
      searchForm: {
      },
      houseFlag: true,
      modalTitle: "新增",
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        img: "",
        sort: 100,
        title: "",
        remark: "",
      },
      addDataRules: {
        img: [{ required: true, message: "请上传图片", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        title: [{ required: true, message: "请输入主题类型名称", trigger: "blur" }],
        remark: [{ required: true, message: "请输入描述", trigger: "blur" }],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    // 修改用户状态
    updataStatus(row) {
      let data = {
        id: row.id,
        status: row.status ? 1 : -1,
      };
      this.$Apis.categoryUpdStatus(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    updataSort(row){
      let data = {
        id: row.id,
        sort: row.sort,
      };
      this.$Apis.categorySort(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.sort = 100
      this.addData.stockNum = ''
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.modalTitle = "修改";
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.categoryDel({ ids:id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    close(){
      this.$refs.form.resetFields();
      this.isAddModal = false;
      for (let item in this.addData) {
        this.addData[item] = "";
      }
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            img: this.addData.img,
            title: this.addData.title,
            remark: this.addData.remark,
            sort: this.addData.sort,
            color: this.addData.color
          };
          this.$Apis.categoryAddUpd(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      this.isShowloading = true;
      this.currentPage = ind == 1 ? 1 : this.currentPage
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        status: this.searchForm.status,
      };
      this.$Apis.categoryGetList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.status = item.status == 1 ? true : false;
            item.ind = ind + 1;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
.color{
  width: 20px;
  height: 20px;
}
.c1{
  background: #A8A200;
}
.c2{
  background: #5CC39B;
}
.c3{
  background: #5E7FC6;
}
.c4{
  background: #79A800;
}
.c5{
  background: #F08300;
}
.el-radio,.el-radio-group{
  display: flex;
  align-items: center;
}
.el-radio-group{
  height: 40px !important;
}
</style>